import { useCheckEmailMutation } from "api/User/hooks.ts";
import { useRef, useState } from "react";

type EmailAvailabilityStatus = "idle" | "taken" | "available";

export function useEmailAvailability() {
    const [status, setStatus] = useState<EmailAvailabilityStatus>("idle");
    const latestEmail = useRef<string>("");

    const checkEmailMutation = useCheckEmailMutation({
        onSuccess: (_data, variables) => {
            if (variables.email === latestEmail.current) {
                setStatus("available");
            }
        },
        onError: (error, variables) => {
            if (variables.email === latestEmail.current) {
                setStatus(error.response?.status === 422 ? "taken" : "idle");
            }
        },
    });

    const checkEmail = (email: string) => {
        latestEmail.current = email;
        if (!email) {
            setStatus("idle");
            return;
        }
        checkEmailMutation.mutate({ email });
    };

    const resetStatus = () => setStatus("idle");

    return {
        emailTaken: status === "taken",
        emailAvailable: status === "available",
        isCheckingEmail: checkEmailMutation.isPending,
        checkEmail,
        resetStatus,
    };
}
